
export const AppMenus = {
    
	navbarTopRight: [],
	navbarTopLeft: [],
	navbarSideLeft: [
  {
    "path": "/home",
    "label": "Inicio",
    "icon": "home",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/calendario",
    "label": "Calendario",
    "icon": "date_range",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/users",
    "label": "Users",
    "icon": "person",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/permissions",
    "label": "Permissions",
    "icon": "vpn_key",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/roles",
    "label": "Roles",
    "icon": "apps",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/calendario/listuser",
    "label": "Calendario Citas",
    "icon": "event_note",
    "iconcolor": "",
    "target": "",
    "submenu": []
  }
],
	calendariolistheader: [
  {
    "label": "Calendarioid",
    "align": "left",
    "sortable": false,
    "name": "calendarioid",
    "field": "calendarioid"
  },
  {
    "label": "Titulo",
    "align": "left",
    "sortable": false,
    "name": "titulo",
    "field": "titulo"
  },
  {
    "label": "Fechainicial",
    "align": "left",
    "sortable": false,
    "name": "fechainicial",
    "field": "fechainicial"
  },
  {
    "label": "Horainicial",
    "align": "left",
    "sortable": false,
    "name": "horainicial",
    "field": "horainicial"
  },
  {
    "label": "Fechafinal",
    "align": "left",
    "sortable": false,
    "name": "fechafinal",
    "field": "fechafinal"
  },
  {
    "label": "Horafinal",
    "align": "left",
    "sortable": false,
    "name": "horafinal",
    "field": "horafinal"
  },
  {
    "label": "Imagen",
    "align": "left",
    "sortable": false,
    "name": "imagen",
    "field": "imagen"
  },
  {
    "label": "Users Id",
    "align": "left",
    "sortable": false,
    "name": "users_id",
    "field": "users_id"
  },
  {
    "label": "Username",
    "align": "left",
    "sortable": false,
    "name": "username",
    "field": "username"
  },
  {
    "label": "Instrucciones",
    "align": "left",
    "sortable": false,
    "name": "instrucciones",
    "field": "instrucciones"
  },
  {
    "label": "Operador",
    "align": "left",
    "sortable": false,
    "name": "operador",
    "field": "operador"
  },
  {
    "label": "Placas",
    "align": "left",
    "sortable": false,
    "name": "placas",
    "field": "placas"
  },
  {
    "label": "Transporte",
    "align": "left",
    "sortable": false,
    "name": "transporte",
    "field": "transporte"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	calendariolistuserheader: [
  {
    "label": "Calendarioid",
    "align": "left",
    "sortable": false,
    "name": "calendarioid",
    "field": "calendarioid"
  },
  {
    "label": "Titulo",
    "align": "left",
    "sortable": false,
    "name": "titulo",
    "field": "titulo"
  },
  {
    "label": "Fechainicial",
    "align": "left",
    "sortable": false,
    "name": "fechainicial",
    "field": "fechainicial"
  },
  {
    "label": "Fechafinal",
    "align": "left",
    "sortable": false,
    "name": "fechafinal",
    "field": "fechafinal"
  },
  {
    "label": "Users Id",
    "align": "left",
    "sortable": false,
    "name": "users_id",
    "field": "users_id"
  },
  {
    "label": "Username",
    "align": "left",
    "sortable": false,
    "name": "username",
    "field": "username"
  },
  {
    "label": "Instrucciones",
    "align": "left",
    "sortable": false,
    "name": "instrucciones",
    "field": "instrucciones"
  },
  {
    "label": "Operador",
    "align": "left",
    "sortable": false,
    "name": "operador",
    "field": "operador"
  },
  {
    "label": "Placas",
    "align": "left",
    "sortable": false,
    "name": "placas",
    "field": "placas"
  },
  {
    "label": "Transporte",
    "align": "left",
    "sortable": false,
    "name": "transporte",
    "field": "transporte"
  },
  {
    "label": "Imagen",
    "align": "left",
    "sortable": false,
    "name": "imagen",
    "field": "imagen"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	permissionslistheader: [
  {
    "label": "Permission Id",
    "align": "left",
    "sortable": false,
    "name": "permission_id",
    "field": "permission_id"
  },
  {
    "label": "Permission",
    "align": "left",
    "sortable": false,
    "name": "permission",
    "field": "permission"
  },
  {
    "label": "Role Id",
    "align": "left",
    "sortable": false,
    "name": "role_id",
    "field": "role_id"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	roleslistheader: [
  {
    "label": "Role Id",
    "align": "left",
    "sortable": false,
    "name": "role_id",
    "field": "role_id"
  },
  {
    "label": "Role Name",
    "align": "left",
    "sortable": false,
    "name": "role_name",
    "field": "role_name"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	userslistheader: [
  {
    "label": "Id",
    "align": "left",
    "sortable": false,
    "name": "id",
    "field": "id"
  },
  {
    "label": "Username",
    "align": "left",
    "sortable": false,
    "name": "username",
    "field": "username"
  },
  {
    "label": "Email",
    "align": "left",
    "sortable": false,
    "name": "email",
    "field": "email"
  },
  {
    "label": "Telephone",
    "align": "left",
    "sortable": false,
    "name": "telephone",
    "field": "telephone"
  },
  {
    "label": "User Role Id",
    "align": "left",
    "sortable": false,
    "name": "user_role_id",
    "field": "user_role_id"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],

    exportFormats: {
        print: {
			label: 'Print',
			color: 'blue',
            icon: 'print',
            id: 'print',
            ext: 'print',
        },
        pdf: {
			label: 'Pdf',
			color: 'red',
            icon: 'picture_as_pdf',
            id: 'pdf',
            ext: 'pdf',
        },
        excel: {
			label: 'Excel',
			color: 'green',
            icon: 'grid_on',
            id: 'excel',
            ext: 'xlsx',
        },
        csv: {
			label: 'Csv',
			color: 'teal',
            icon: 'grid_on',
            id: 'csv',
            ext: 'csv',
        },
    },
    
}